/**
 * @ngdoc component
 * @name catalog.component:ItxProductInfo
 * @requires $rootScope
 * @requires ngDialog
 * @requires imProductService
 * @requires ItxSizeGuideSvc
 * @description
 * Product information details.
 * This component will show the following product information:
 * - Details
 * - Composition and care
 * - Shipping information
 * - Return information
 * 
 */

(function() {

    'use strict';

    var ItxProductInfoCmp = {
        bindings: {
            product: '<',
            productComplete:'<',
            closeDialog: '&',
            selectedColorIndex: '<',
            hasDialog: '<'
        },
        controller: ItxProductInfoCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'product-info.component.html'
    };

    ItxProductInfoCmpCtrl.$inject = [
        '$rootScope',
        'ngDialog',
        'imProductService',
        'ItxSizeGuideSvc',
        'ItxStaticResourceSvc',
        'ProductInfoService',
        'ItxTranslateSvc',
        'ItxChatSvc',
        'timestampSvc',
        'ItxStyleAdvisorSvc',
        'UserService',
        'crmService',
        'ItxLoginSvc',
        'mdFeelSuscriptionService',
        'CmsConstant'
    ];

    function ItxProductInfoCmpCtrl( 
        $rootScope, 
        ngDialog, 
        imProductService, 
        ItxSizeGuideSvc,
        ItxStaticResourceSvc,
        ProductInfoService,
        ItxTranslateSvc,
        ItxChatSvc,
        timestampSvc,
        ItxStyleAdvisorSvc,
        UserService,
        crmService,
        ItxLoginSvc,
        mdFeelSuscriptionService,
        CmsConstant
    ) {
        var _this = this;

        _this.slug = CmsConstant.content.productinfo;

        $rootScope.$on('screen-size:desktop', function() {
            _this.closeDialog();
        });

        _this.$onInit = function(){
           
            _this.init();
            
        };
        _this.$onChanges = function(changes){
            
            
            if(changes.product && !changes.product.isFirstChange()){
                _this.init();
            }
            if(changes.selectedColorIndex){
                
                if(_this.product && _this.product.activeDetail){
                    
                    _this.getCompositions();
                }
            }
            if(changes.productComplete && _this.productComplete){
                _this.getCompositions();
            }
        };
        
        _this.init = function() {
            // _this.compositionParts = [];
            _this.shippingMethods = [];
            _this.returnable = true;
            _this.showStock = false;
            _this.capitalize = _.capitalize;
            _this.showDeliveryInfo = false;
            _this.madeIn = null;
            _this.showSpecialMspotFamilies = false;
            _this.isUniqueSize = ItxSizeGuideSvc.isUniqueSize(_this.product, _this.selectedColorIndex);
            _this.productDescriptions = [];
           
            _this.iconSizeGuide = ItxStaticResourceSvc.getImage('icon_size_guide.svg');
                    
            inditex.getXconfiguracionValue('SHOW_LOCAL_STORE', function(status, value) {
                 _this.showStock = (value === 'SHOW');
            });
            
            inditex.getXconfiguracionValue('SHOW_SPECIAL_MSPOT_FAMILIES', function(status, value) {
                _this.showSpecialMspotFamilies = value && value !== '0';
            });
    
            if (_this.showStock) {
                inditex.getXconfiguracionValue('SEASONS_STOCK_QUERY_ALLOWED', function(status, value) {
                    if (value && _this.product) {
                        var seasonProduct = _this.product.activeDetail.reference.split('-')[1];
                        var allowedSeasons = value.split(',');
                        _this.showStock = allowedSeasons.indexOf(seasonProduct) >= 0 && seasonProduct != null;
                    }
                });
            }

            if(!_this.product) {return;}
            
            $.each(_this.product.attributes, function(i, attribute) {
                if (attribute.name === 'NORETURN' || attribute.name === 'NORETURN_' + inditex.iStoreJSON.countryCode) {
                    _this.returnable = false;
                }
                if (attribute.name.indexOf('MADEIN_') !== -1) {
                    _this.madeIn = attribute.value;
                }
                if(attribute.type == 'DESCRIPTION'){
                    _this.productDescriptions.push(attribute);
                }
            });

            // Si el producto no está rabajado
            if (!checkIfDiscounted()) {
                // Comprueba si Style Advisor está activo
                ItxStyleAdvisorSvc.checkIfEnabled().then(function (isActive) {
                    _this.isStyleAdvisorEnabled = isActive;
                });
            }
        };

        _this.isOpenForSale = joyr.catalog.utils.isOpenForSale.bind(inditex);

        _this.openStock = function() {
            ngDialog.open({
                template: '<itx-product-stock color="ngDialogData.color" detail="ngDialogData.detail" reference="ngDialogData.reference" close-dialog="closeThisDialog()"></itx-product-stock>',
                plain: true,
                className: 'new-modal ma-modal-lg  store-check-dialog ngdialog-theme-plain',
                showClose: true,
                data: {
                    color: _this.product.activeDetail.colors[_this.selectedColorIndex || 0],
                    reference: _this.product.activeDetail.reference,
                    detail: _this.product.activeDetail
                }
            });

            /**
             * IMAnalytics trigger evento reservar en tienda
             */
            imProductService.eventStoreStock(_this.product, _this.selectedColorIndex);
        };


        _this.shallHideMSProductSpecial = function() {
            return !_this.returnable;
        };

        _this.goToHelpPage = function() {
            // IMAnalytics - ver_ayuda
            imProductService.eventHelpPage(_this.product);
            ngDialog.open({
                template: '<itx-contact close="closeThisDialog()"></itx-contact>',
                plain: true,
                className: 'product-info ngdialog-theme-plain new-modal ma-modal-lg ',
                showClose: true
            });

            document.body.addEventListener('click', function(e) {
                if($(e.target).hasClass('openChat')) {
                    dialog.close();
                    ItxChatSvc.showChat();
                }
            });
        };
       
        /**
         * @ngdoc method
         * @methodOf catalog.component:ItxProductInfo
         * @name getCompositions
         * @description
         * Fill composition array with information from composition and compositionByZone arrays.
         */
        _this.getCompositions = function() {
            
            _this.compositionParts = [];
            //Try to use mocaco composition else select the moca composition
            if( _this.product.activeDetail.colors[_this.selectedColorIndex || 0].composition &&  _this.product.activeDetail.colors[_this.selectedColorIndex || 0].composition.length > 0)
            {
                _this.composition  = angular.copy(_this.product.activeDetail.colors[_this.selectedColorIndex || 0].composition);
            }
            else{
                _this.composition = angular.copy(_this.product.activeDetail.composition);
            }

            if( _this.product.activeDetail.colors[_this.selectedColorIndex || 0].compositionByZone &&  _this.product.activeDetail.colors[_this.selectedColorIndex || 0].compositionByZone.length > 0)
            {
                _this.compositionByZone  = angular.copy(_this.product.activeDetail.colors[_this.selectedColorIndex || 0].compositionByZone);
            }
            else{
                _this.compositionByZone = angular.copy(_this.product.activeDetail.compositionByZone);
            }
            
            for (var i = 0; i < _this.composition.length; i++) {
                
                var compositionPart = _this.composition[i];

                var compositionByZone = _this.getCompositionByZone(compositionPart.part);
                
                if(compositionByZone){
                    compositionPart = compositionByZone;
                }
                
                compositionPart.name = _this.getCompositionName(compositionPart.part);
                
                _this.addComposition(compositionPart);
            }

        };
        /**
         * @ngdoc method
         * @methodOf catalog.component:ItxProductInfo
         * @private
         * @name addComposition
         * @description
         * Push composition to the array of compositions.
         * If general composition part exists in the array, then concatenate composition part to the array of compositions from part.
         * If zone composition exists, then return.
         * Otherwise add the given composition to the array.
         */
        _this.addComposition = function(compositionPart){
            for (var i = 0; i < _this.compositionParts.length; i++) {                
                if(_this.compositionParts[i].part==compositionPart.part){
                    if(!_this.compositionParts[i].zones){
                        _this.compositionParts[i].composition.push(compositionPart.composition[0]);
                    }
                    return;
                }
            }
            _this.compositionParts.push(compositionPart);
        };
        /**
         * @ngdoc method
         * @methodOf catalog.component:ItxProductInfo
         * @name getCompositionName
         * @description
         * Get the composition name checking if it is clothing or footwear.
         * If `product.activeDetail.reference.substr(0, 1) === '0'` clothing else footwear.
         * @returns {string} name - Composition Name
         */
        _this.getCompositionName = function(part){
            return ItxTranslateSvc.translate((_this.product.activeDetail.reference.substr(0, 1) === '0' ? 'comp_clothing' : 'comp_footwear') + '_' + part);
        };
        /**
         * @ngdoc method
         * @methodOf catalog.component:ItxProductInfo
         * @name getCompositionByZone
         * @description
         * Check if the given general part has a relative zone part.
         * If so, then unify same zone parts and return object.
         * @returns {object | null} compositionZonePart - Composition object
         */
        _this.getCompositionByZone = function(part){

            for (var i = 0; i < _this.compositionByZone.length; i++) {
                var compositionZonePart = _this.compositionByZone[i],
                    found = false;
                if(compositionZonePart.part==part){
                    var zones = [];
                    angular.forEach(compositionZonePart.zones, function(zoneComposition){
                        found=false;
                         for(var j=0; j < zones.length; j++){
                            if(zones[j].zone==zoneComposition.zone){
                                zones[j].composition.push(zoneComposition.composition[0]);
                                found=true;
                                break;
                            }
                        }
                        if(!found){
                            zones.push(zoneComposition);
                        }
                    });
                    compositionZonePart.zones = zones;
                    return compositionZonePart;                    
                }
            }
            return null;
        };

        _this.generateCareImageUrl = function(careId) {
            // var self = this;
            var result;
            var carePathStore;
            var itxConf = inditex.iStoreJSON.configurations;
            if (location.protocol == 'https:') {
                result = inditex.iStoreJSON.details.staticUrl.replace('http:', 'https:');
            } else {
                result = inditex.iStoreJSON.details.staticUrl.replace('https:', 'http:');
            }
            for (var x = 0; x < itxConf.length; x++) {
                if (itxConf[x].parametro == 'CARES_STATIC_PATH') {
                    carePathStore = itxConf[x].valor;
                }
            }
            result += result[result.length - 1] == '/' ? '' : '/';
            result += 'itxwebstandard/images/cares/';
            result += carePathStore + '/';
            result += careId;
            result += '.';
            result += 'png';
            return result + '?' + timestampSvc.getTs();
        };


        // @Type allowed [details, cares, send, returns, product-information-extended]
        var typeActive = 'details';
        _this.clickOpenAccordion = function(type, event) {

            event.preventDefault();
            
            var parent = _this.hasDialog ? '.ngdialog ' : '';
            var boxInfo = 'ma-product-ac-inner';
            
            // Cerramos los que estén abiertos
            $(parent + ' li').removeClass('active');
            $(parent + '.' + boxInfo).slideUp(350);
            
            // Get the shipping methods
            if(type=='send' && typeActive!='send'){
                _this.showDeliveryInfo = true;
            }

            // Si no esta cerrado
            if(typeActive != type){
                typeActive = type;
                // Abrimos el seleccionado y marcamos el li con .active
                $(parent + '.' + type + ' .' + boxInfo).slideToggle(350);
                $(parent + '.' + type).addClass('active');
            } 
            else{
                typeActive = 'none';
            }

            // Para detalles o información extendida del producto no lanzamos evento de analitica
            if(type != 'details' && type != 'product-information-extended'){
                imProductService.eventProductInfo(_this.product, type);    
            }
            
        };

        /**
         * Función para abrir Style Advisor
         */
        _this.openStyleAdvisor = function () {
            // Comprueba que el usuario esté autenticado
            if (UserService.isAuthenticated()) {
                // Abre el chat de Style Avisor solo en caso de que el usuario esté suscrito al programa Feel
                if (crmService.is360()) {
                    ItxChatSvc.openStyleAdvisor();
                } else {
                    mdFeelSuscriptionService.openCrmPopup();
                }
            } else {
                // Añadimos en local storge un control para especificar que hemos intentado abrir Style Advisor
                inditex.setLocalStorage('openStyleAdvisorAttempt', true);
                ItxLoginSvc.popupSignIn();
            }
        };

        /**
         * Función para comprobar si el producto está rebajado
         */
        function checkIfDiscounted() {

            if(_this.product.activeDetail.colors.length > 0 && _this.product.activeDetail.colors[0].sizes.length > 0) {
                if(_this.product.activeDetail.colors[0].sizes[0].oldPrice) {
                    return true;
                }
            }

            return false;
        }
        

    }

    angular.module('itxApp.catalog')
        .component('itxProductInfo', ItxProductInfoCmp);

})(window.itxApp);